<div class="oneInfoConsulting">
    <p class="oneInfoText">Powered by </p>
    <img class="logoOneInfoConsulting" src="../../../../assets/oneinfoconsulting.svg">
</div>
